import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa6c3e9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "refresh" }
const _hoisted_2 = { class: "image__preview" }
const _hoisted_3 = { class: "img-list" }
const _hoisted_4 = { class: "image-tag" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-images" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash-can" })
], -1))
const _hoisted_9 = { class: "paging-image" }

import { ref, onMounted } from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import { apiGetNoParam } from '@/api/index'
import { ECM_DELETE } from '@/api/const/file'
import messageShow from '@/utils/MessageShow'

interface Props {
  apiImages: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Galaxy',
  props: {
    apiImages: { default: '' }
  },
  emits: ['close', 'choiceBanner'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const fileList = ref<any[]>([])
const page = ref(1)
const size = ref(8)
const total = ref(0)

onMounted(() => {
  getImagesList()
})

const getImagesList = async () => {
  const res: any = await apiGetNoParam(
    props.apiImages + '?page=' + page.value + '&size=' + size.value
  )

  const data = res.data.data
  fileList.value = data.body
  total.value = data.total || data.body.length
}

const deleteImage = async (id: any) => {
  const res: any = await apiGetNoParam(ECM_DELETE + id)
  const ok = res.data.data

  if (ok) {
    messageShow.success(t('text.deleteFile'), t('text.deleteFileSuccess'))
    removeFileById(id)
  } else {
    messageShow.error(t('text.deleteFile'), t('text.deleteFileFailed'))
  }
}

const removeFileById = (id: number) => {
  fileList.value = fileList.value.filter(item => item.id !== id);
};

const confirmEvent = (file: any) => {
  deleteImage(file.id)
}

const choiceFile = (file: any) => {
  emit('choiceBanner', file)
}

const handleSizeChange = (_: number, newSize: number) => {
  size.value = newSize
  getImagesList()
}

const handleCurrentChange = (newPage: number) => {
  page.value = newPage
  getImagesList()
}

return (_ctx: any,_cache: any) => {
  const _component_h_button = _resolveComponent("h-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_h_button, {
        type: "primary",
        onClick: getImagesList
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(SearchOutlined))
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$t('text.reload')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file) => {
          return (_openBlock(), _createElementBlock("div", {
            key: file.id,
            class: "img-item"
          }, [
            _createVNode(_component_a_image, {
              src: file.imageUrl,
              style: {"width":"100%"}
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_tooltip, {
                title: _ctx.$t('text.useImage')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (choiceFile(file))
                  }, _hoisted_7, 8, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(_component_a_popconfirm, {
                title: _ctx.$t('message.confirmDelete'),
                "ok-text": _ctx.$t('btn.ok'),
                "cancel-text": _ctx.$t('btn.cancel'),
                onConfirm: ($event: any) => (confirmEvent(file))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, {
                    title: _ctx.$t('text.deleteImage')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 2
              }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_a_pagination, {
        current: page.value,
        "page-size": size.value,
        total: total.value,
        "page-size-options": ['8','12','24','36','50'],
        "show-size-changer": "",
        onChange: handleCurrentChange,
        onShowSizeChange: handleSizeChange
      }, null, 8, ["current", "page-size", "total"])
    ])
  ]))
}
}

})